import React from "react";
import {
  InputAdornment,
  TextField,
  styled,
  StandardTextFieldProps,
  Button,
} from "@mui/material";

const StyledTextField = styled(TextField)(() => ({
  paddingRight: 4,
  paddingTop: 8,
  paddingBottom: 8,
  "& .MuiButton-root": {
    height: 31,
    borderRadius: 13,
    fontSize: 14,
    fontWeight: 400,
    padding: "0px 19px",
  },
  "& .MuiInputBase-root": {
    height: "100%",
  },
  "& .MuiInputAdornment-root": {
    color: "rgba(18, 18, 18, 0.5)",
  },
}));
interface InputFieldWithButtonInterface extends StandardTextFieldProps {
  placeholder?: string;
  buttonLabel: string;
  onClick: () => void;
  isLight?: boolean;
}
const InputFieldWithButton = ({
  placeholder,
  buttonLabel,
  onClick,
  isLight = false,
  ...props
}: InputFieldWithButtonInterface) => {
  return (
    <StyledTextField
      {...props}
      variant="standard"
      placeholder={placeholder}
      InputProps={{
        disableUnderline: true,
        className: isLight ? "font-white" : "font-black",
        endAdornment: (
          <InputAdornment position="end">
            <Button variant="contained" onClick={onClick}>{buttonLabel}</Button>
          </InputAdornment>
        ),
      }}
    />
  );
};
export default InputFieldWithButton;
